module.exports = __webpack_public_path__ + "d01457362adf034c3ef8c62bbf33afe0.svg";


//////////////////
// WEBPACK FOOTER
// ./process/assets/l_up_arrow.svg
// module id = 149
// module chunks = 0